import { render } from "./ProgressBar.vue?vue&type=template&id=4973409c"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=4973409c&lang=css"
script.render = render

export default script